import { Button, Checkbox, Pagination, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/react"
import { ExtractorType } from "../../types/types"
import { useMemo, useState } from "react"
import { useFirestore, useFirestoreCollectionData, useFunctions } from "reactfire"
import { collection, orderBy, query } from "firebase/firestore"
import { httpsCallable } from "firebase/functions"

export interface PublishProps {
  ext: ExtractorType
}
export const Publish: React.FC<PublishProps> = ({ ext }) => {

  const firestore = useFirestore();
  const functions = useFunctions();

  const [response, setResponse] = useState<any>();


  const { data: publishLog } = useFirestoreCollectionData(
    query(collection(firestore, `extractors/${ext.id}/publishlog`), orderBy('publishedAt', "desc")), { idField: 'logId' });
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const pages = Math.ceil((publishLog ? publishLog.length : 0) / rowsPerPage);

  const items = useMemo(() => {
    if (publishLog) {
      const start = (page - 1) * rowsPerPage;
      const end = start + rowsPerPage;

      return publishLog.slice(start, end);
    }
    return [];
  }, [page, publishLog]);


  const publishExtractor = async () => {
    var fnName = 'api/publish/' + ext.id;

    const callableFunction = httpsCallable(functions, fnName);
    const result = await callableFunction(
      {
        requestedExtractorId: ext.id,
      }
    );
    console.log(result);
    setResponse(result.data);
  }
  return (
    <div className="flex w-full min-h-[65vh]">
      <div className="flex columns-2 gap-5 w-full">
        <div className="flex-1 overflow-y-auto p-4 bg-base-100  ">
          <div className="mt-2">
            <div className="flex columns-2 gap-5 w-full justify-between">
              <div>
                <div className="text-lg">Publish</div>
                <span className="text-sm">Publish a version of the extractor for Production use</span>
              </div>
              <div className="flex justify-end">
                <Button color="primary" aria-label="Publish" onClick={publishExtractor}>
                  Publish
                </Button>
              </div>
            </div>
          </div>

          <div className="mt-2">
            <Table
              aria-label="Publish Log"
              removeWrapper
              bottomContent={
                <div className="flex w-full justify-center">
                  <Pagination
                    isCompact
                    showControls
                    showShadow
                    color="secondary"
                    page={page}
                    total={pages}
                    onChange={(page) => setPage(page)}
                  />
                </div>
              }
              classNames={{
                wrapper: "min-h-[222px]",
              }}
            >
              <TableHeader>
                <TableColumn>Live</TableColumn>
                <TableColumn>Description</TableColumn>
                <TableColumn>Published By</TableColumn>
                <TableColumn>Published On</TableColumn>
              </TableHeader>
              <TableBody
                emptyContent={"No rows to display"}
                items={items}>
                {(item) => {
                  const log = item as any;
                  return (
                    <TableRow key={log.logId}>
                      <TableCell>{log.logId === ext.live.publishedId ? <Checkbox isDisabled defaultSelected></Checkbox> : ""}</TableCell>
                      <TableCell>{log.description}</TableCell>
                      <TableCell>{log.publishedBy}</TableCell>
                      <TableCell>{dateFormatter.format(new Date(log.publishedAt.seconds * 1000))}</TableCell>
                    </TableRow>
                  )
                }}

              </TableBody>
            </Table>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-4 bg-base-100 mt-2 ">
          <div className="mt-2">
            <div className="text-lg">Instructions</div>
            <span className="text-sm">Use the following API to integrate with your application </span>
          </div>

        </div>
      </div>


    </div>
  )
}